/**
 * 协会的真实对外信息 —— **全端唯一真源**。
 *
 * ★ 2026-08-26 P6：此前手机端「我的」页（`pages/Profile.tsx`）自己写了一份
 *   `TEL_DISPLAY / TEL_HREF` ＋ 一行硬编码地址，本文件另写一份，两份**同值分叉**。
 *   分叉的代价是确定的：主公这次给的是**真号真地址**，只改一处就会出现
 *   「手机端说新地址、PC 表单页脚说旧地址」。现在合并完毕 ——
 *   Profile.tsx 与 pc/PcApp.tsx 都从这里 import，`packages/citizen` 内**再无第二份**。
 *
 * ★ 值的来历：2026-08-26 主公给定，非我方编写、非从旧稿沿用。
 *   电话**两个都是有效号码**，页面要两个都露出来，不许只挑一个显示。
 */

export const ASSOC_NAME = '成都市房地产经纪协会';

/** 咨询电话（两条线并列，都要显示；顺序即主公给定顺序） */
export const ASSOC_TELS = [
  { display: '86272763', href: 'tel:86272763' },
  { display: '86278035', href: 'tel:86278035' },
] as const;

/**
 * 单号位兼容出口：给「版面上只放得下一个号」的地方用。
 * 取第一条线。**新代码不要用它** —— 两个号都有效，能放两个就放两个。
 *
 * ★ 2026-09-08 起 PC 投诉页页头改用下面的 `ASSOC_COMPLAINT_TEL`，不再走这个出口；
 *   PC 页脚仍用 `ASSOC_TELS`（两个号都列）。
 */
export const ASSOC_TEL_DISPLAY = ASSOC_TELS[0].display;
export const ASSOC_TEL_HREF = ASSOC_TELS[0].href;

/**
 * **投诉咨询电话**（2026-09-08 主公给定）。
 *
 * ★ 与上面的 `ASSOC_TELS` **不是一回事，别合并**：
 *   那两个是协会的**总咨询**线；这一个是**投诉专线** —— 打进去问的是投诉怎么填、
 *   材料怎么传、进度到哪儿。PC 投诉页右上角要露的正是这一个：
 *   人在填表单时卡住了要找的是管投诉的人，给他总机等于让他再被转一道。
 *
 * ★ 目前只用在 PC 投诉页页头。手机端与 PC 页脚仍列总咨询那两个号 ——
 *   主公这次只点了「PC 端投诉右上角」，没说要替换别处，不擅自扩大。
 */
export const ASSOC_COMPLAINT_TEL = { display: '86280032', href: 'tel:86280032' } as const;

export const ASSOC_TEL_HOURS = '工作日 9:00-12:00 / 13:00-17:00';
export const ASSOC_ADDRESS = '成都市青羊区西华门街17号 天府中心913';
